import { getField, updateField } from 'vuex-map-fields';
import OnlineScheduling from '../../api/online-scheduling';

// initial state
const state = {
    clinicUrl: null,
    step: 1,
    appointmentType: null,
    loading: true,
    clinic: null,
    staff: null,
    patient: null,
    timeslot: null,
    appointments: [],
    companionTypes: [],
    globals: {
        changeLocations: 'locations',
        returnToHomepage: '',
    }
};

// getters
const getters = {
    getField
};

// actions
const actions = {
    resetData({ commit }) {
        commit('setStateValue', { key: 'clinicUrl', value: null });
        commit('setStateValue', { key: 'appointmentType', value: null });
        commit('setStateValue', { key: 'loading', value: true });
        commit('setStateValue', { key: 'clinic', value: null });
        commit('setStateValue', { key: 'staff', value: null });
        commit('setStateValue', { key: 'patient', value: null });
        commit('setStateValue', { key: 'timeslot', value: null });
        commit('setStateValue', { key: 'appointments', value: [] });
        commit('setStateValue', { key: 'companionTypes', value: [] });
        commit('setStateValue', { key: 'step', value: 1 });
    },
    getClinicInformation({ commit, rootState }, { clinicUrl, dealerId, clientToken, cb }) {
        OnlineScheduling.getClinicInformation((data) => {
            const clinic = Array.isArray(data?.data) ? data.data[0] ?? null : null;

            commit('setStateValue', { key: 'clinic', value: clinic });
            if (cb) {
                cb(clinic);
            }
        }, { clinicUrl, dealerId, clientToken });
    },
    getStaff({ commit }, { clinicId, dealerId, clientToken, cb }) {
        OnlineScheduling.getStaff((data) => {
            const matchingStaff = Array.isArray(data)
                ? data.find(staff => staff.firstName?.endsWith(' P.')) || null
                : null;

            commit('setStateValue', { key: 'staff', value: matchingStaff });

            if (cb) {
                cb(matchingStaff);
            }
        }, { clinicId, dealerId, clientToken });
    },
    getAppointmentTimeslots({ commit, rootState }, { startDate, endDate, appointmentType, clinicId, staffId, dealerId, clientToken, cb }) {
        OnlineScheduling.getAppointmentTimeslots((data) => {
            commit('setStateValue', { key: 'appointments', value: Array.isArray(data) ? data : [] });
            if (cb) {
                cb();
            }
        }, { startDate, endDate, appointmentType, clinicId, staffId, dealerId, clientToken });
    },
    getCompanionTypes({ commit, rootState }, { dealerId, clientToken, cb }) {
        OnlineScheduling.getCompanionTypes((data) => {
            commit('setStateValue', { key: 'companionTypes', value: Array.isArray(data) ? data : [] });
            if (cb) {
                cb();
            }
        }, { dealerId, clientToken });
    },
    postScheduleAppointment({ commit, rootState }, { data, dealerId, clientToken, cb }) {
        OnlineScheduling.postScheduleAppointment((data) => {
            if (cb) {
                cb();
            }
        }, { data, dealerId, clientToken });
    },
};

// mutations
const mutations = {
    updateField,
    setStateValue(state, payload) {
        state[payload.key] = payload.value;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
